<template>
  <modal
    v-slot="{ data: { items } }"
    name="itemsExceedingInventory"
    modal-style="compact"
    :display-header-title="false"
    :is-required="true"
  >
    <items-exceeding-inventory :items="items" />
  </modal>
</template>


<script>
  import ItemsExceedingInventory from './items-exceeding-inventory/index.vue';


  export default {
    name: 'ItemsExceedingInventoryModal',

    components: {
      ItemsExceedingInventory
    }
  };
</script>
